import Vue from 'vue'
import Vuex from 'vuex'

import Magnetight from './products/magnetight'
import NoMoreBaggage from './products/nomorebaggage'
import PoresNoMore from './products/poresnomore'
import SayILoveYou from './products/sayiloveyou'
import VeggieBullet from './products/veggiebullet'
import NutribulletPro from './products/nutribulletpro'
import Nutribullet from './products/nutribullet'

Vue.use(Vuex)

const state = {
  carts: {
    magnetight: Magnetight,
    nomorebaggage: NoMoreBaggage,
    poresnomore: PoresNoMore,
    nutribulletpro: NutribulletPro,
    magicbullet: Nutribullet,
    veggiebullet: VeggieBullet,
    SAYILOVEYOU: SayILoveYou
  },
  constants: {
    'POWERED_BY_TEXT': {
      default: 'Powered by'
    }
  }
}

const mutations = {}

const actions = {}

const store = new Vuex.Store({
  state,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js